// SidebarContext.js
import  { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    // Return default values if context is not available
    return {
      collapsed: false,
      setCollapsed: () => {},
      toggleCollapsed: () => {},
      mobileDrawerVisible: false,
      setMobileDrawerVisible: () => {},
      openMobileDrawer: () => {},
      closeMobileDrawer: () => {}
    };
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState(false);
  
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const openMobileDrawer = () => {
    setMobileDrawerVisible(true);
  };

  const closeMobileDrawer = () => {
    setMobileDrawerVisible(false);
  };

  return (
    <SidebarContext.Provider value={{ 
      collapsed, 
      setCollapsed,
      toggleCollapsed, 
      mobileDrawerVisible, 
      setMobileDrawerVisible,
      openMobileDrawer, 
      closeMobileDrawer 
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
